import React from 'react';
import PropTypes from 'prop-types';
import reduce from 'lodash/reduce';
import classnames from 'classnames';

import { Paragraph } from 'components/core/Typography';
import FacilityHourItem from './FacilityHourItem';

import './facilityHoursList.scss';

export const hoursShape = PropTypes.shape({
	sunday: PropTypes.string.isRequired,
	monday: PropTypes.string.isRequired,
	tuesday: PropTypes.string.isRequired,
	wednesday: PropTypes.string.isRequired,
	thursday: PropTypes.string.isRequired,
	friday: PropTypes.string.isRequired,
	saturday: PropTypes.string.isRequired
}).isRequired;

export function FacilityHoursList({ className, hours, listTitle , showFullDay}) {
	return (
		<div className={classnames(className, 'facility-hours-list')}>
			<Paragraph className="hours-list-title">
				{listTitle}
			</Paragraph>
			<ul className="hours-list">
				{reduce(hours, (hourComponents, val, key) => {
					hourComponents.push(
						<FacilityHourItem
							key={key}
							dayName={key}
							dayNameFormat={showFullDay ? "" : "abbreviated"}
							openTime={val}
						/>
					);
					return hourComponents;
				}, [])}
			</ul>
		</div>
	);
}

FacilityHoursList.propTypes = {
	className: PropTypes.string,
	/** A map of hours, DOW name -> time range string */
	hours: hoursShape,
	/** Title for the list of hours. e.g. "Office hours", "Access hours" */
	listTitle: PropTypes.string.isRequired,
	showFullDay: PropTypes.bool
};

FacilityHoursList.defaultProps = {
	showFullDay: false
};

export default FacilityHoursList;
